import { useSessionFile } from '../../hooks/session-file-hook';
import React, { useRef, useState, useEffect } from 'react';

import Button from './Button';
import './ImageUploads.css';

const ImageUpload = (props) => {
  const [image, setImage, fileStatus] = useSessionFile(props.storageKey);
  const [previewUrl, setPreviewUrl] = useState();
  const [isValid, setIsValid] = useState(!!image);

  const filePickerRef = useRef();
  const { id, onInput } = props;
  useEffect(() => {
    if (image) onInput(id, image, true);
  }, [id, image, onInput]);

  useEffect(() => {
    if (!image) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result);
    };
    fileReader.readAsDataURL(image);
  }, [image]);

  const pickedHandler = (event) => {
    let pickedFile;
    let fileIsValid = isValid;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setImage(pickedFile);
      setIsValid(true);
      fileIsValid = true;
    } else {
      setIsValid(false);
      fileIsValid = false;
    }
    props.onInput(props.id, pickedFile, fileIsValid);
  };

  const pickImageHandler = () => {
    filePickerRef.current.click();
  };

  return (
    <div className="form-control">
      <input
        id={props.id}
        ref={filePickerRef}
        style={{ display: 'none' }}
        type="file"
        accept=".jpg,.png,.jpeg"
        onChange={pickedHandler}
      />
      <div className={`image-upload ${props.center && 'center'}`}>
        <div className="image-upload__preview">
          {previewUrl && <img src={previewUrl} alt="Preview" />}
          {!previewUrl && <p>Please pick an image.</p>}
        </div>
        <Button type="button" onClick={pickImageHandler}>
          PICK IMAGE
        </Button>
      </div>
      {image && (
        <p className="session-save-note">
          {fileStatus === 'unavailable'
            ? 'Image could not fit in tab storage. Please reselect it after leaving this page.'
            : fileStatus === 'saving'
              ? 'Keeping image in this tab…'
              : `${image.name} selected`}
        </p>
      )}
      {!isValid && <p>{props.errorText}</p>}
    </div>
  );
};

export default ImageUpload;
